// Sidebar Routers
export const menus = {
  // 'message.general': [
  // 	{
  // 		action: 'zmdi-view-dashboard',
  // 		title: 'message.dashboard',
  // 		active: true,
  // 		items: [
  // 			{ title: 'message.ecommerce', path: 'dashboard/ecommerce'},
  // 			{ title: 'message.webAnalytics', path: 'dashboard/web-analytics'},
  // 			{ title: 'message.magazine', path: 'dashboard/magazine'},
  // 			{ title: 'message.news', path: 'dashboard/news'},
  // 			{ title: 'message.agency', path: 'dashboard/agency'},
  // 			{ title: 'message.saas', path: 'dashboard/saas'}
  // 		]
  // 	}
  // ],
  // 'message.tongQuan': [
  // 	{
  // 		action: 'zmdi-view-dashboard',
  // 		title: 'message.tongQuan',
  // 		active: true,
  // 		path: 'dashboard',
  // 		items: null,
  // exact: true
  // 	},
  // ],
  "message.phieu": [
    {
      action: "zmdi-assignment",
      title: "message.baoCaoNhanCoc",
      active: false,
      path: "bao-cao-nhan-coc",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuThongTinNhanPhong",
      active: false,
      path: "phieu-thong-tin-nhan-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuBaoTraPhong",
      active: false,
      path: "phieu-bao-tra-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuThayDoiThongTin",
      active: false,
      path: "phieu-thay-doi-thong-tin",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuThuTienPhong",
      active: false,
      path: "phieu-thu-tien-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuThuChi",
      active: false,
      path: "phieu-thu-co-gam",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuChi",
      active: false,
      path: "phieu-chi",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuDieuChinh",
      active: false,
      path: "phieu-dieu-chinh",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.bangSoDien",
      active: false,
      path: "bang-so-dien",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.bangSoNuoc",
      active: false,
      path: "bang-so-nuoc",
      items: null,
      exact: true,
    },
  ],
  "message.quanLyChungTu": [
    {
      action: "zmdi-assignment",
      title: "message.phieuCocLienTuc",
      active: false,
      path: "phieu-coc-lien-tuc",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-assignment",
      title: "message.phieuCocSaiFormat",
      active: false,
      path: "phieu-coc-sai-format",
      items: null,
      exact: true,
    },
  ],
  "message.quanLyPhong": [
    {
      action: "zmdi-collection-text",
      title: "message.theoDoiTinhTrangCoc",
      active: true,
      path: "theo-doi-tinh-trang-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-collection-text",
      title: "message.bangTheoDoiCoc",
      active: true,
      path: "theo-doi-coc",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-collection-text",
      title: "message.thongTinPhong",
      active: true,
      path: "thong-tin-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-collection-text",
      title: "message.kiemSoatDienNuoc",
      active: true,
      path: "kiem-soat-dien-nuoc",
      items: null,
      exact: true,
    },
  ],
  "message.quanLyKhachHang": [
    {
      action: "zmdi-collection-text",
      title: "message.bangHopDong",
      active: true,
      path: "hop-dong-thue-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-account-box",
      title: "message.bangKhachHang",
      active: true,
      path: "bang-khach-hang",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-bike",
      title: "message.inTheXe",
      active: true,
      path: "the-xe",
      items: null,
      exact: true,
    },
  ],
  "message.quanLyTaiChinh": [
    {
      action: "zmdi-view-dashboard",
      title: "message.bangTinhTien",
      active: true,
      path: "bang-tinh-tien",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.danhSachNoTienPhong",
      active: true,
      path: "danh-sach-no-tien-phong",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.bangTinhTienTraCoc",
      active: true,
      path: "bang-tinh-tien-tra-coc",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.tienDanPhong",
      active: true,
      path: "tien-dan-phong",
      items: null,
      exact: true,
    },
    // {
    // 	action: 'zmdi-view-dashboard',
    // 	title: 'message.bcTienPhongChuaThu',
    // 	active: true,
    // 	path: 'bao-cao-tien-phong-chua-thu',
    // 	items: null,
    // exact: true
    // },
    {
      action: "zmdi-view-dashboard",
      title: "message.soTienMat",
      active: true,
      path: "so-tien-mat",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.soTienNganHang",
      active: true,
      path: "so-tien-ngan-hang",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.nhatKyChung",
      active: true,
      path: "nhat-ky-chung",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.bangTongHopCongNo",
      active: true,
      path: "bang-tong-hop-cong-no",
      items: null,
      exact: true,
    },
    {
      action: "zmdi-view-dashboard",
      title: "message.bangTongHopCongNoKhac",
      active: true,
      path: "bang-tong-hop-cong-no-khac",
      items: null,
      exact: true,
    },
    // {
    // 	action: 'zmdi-view-dashboard',
    // 	title: 'message.tienCocChuaThu',
    // 	active: true,
    // 	path: 'bao-cao-tien-coc-chua-thu',
    // 	items: null,
    // exact: true
    // },
  ],
  "message.internet": [
    {
      action: "zmdi-wifi-alt",
      title: "message.quanLyInternet",
      active: true,
      path: "internet",
      items: null,
      exact: true,
    },
  ],
  "message.user": [
    {
      action: "zmdi-face",
      title: "message.quanLyLog",
      active: true,
      path: "logs",
      items: null,
      exact: true,
    },
  ],
};
